/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
$(document).ready(function () {
  // Fetch the cart on page load
  ShopifyAPI.getCart(function (cart) {
    let itemsToUpdate = [];
    let itemsProcessed = 0;

    // Iterate through all cart items
    $.each(cart.items, function (index, cartItem) {
      const productHandle = cartItem.handle;
      const variantId = cartItem.variant_id;

      // Fetch the minimum order quantity
      $.get(`/products/${productHandle}?variant=${variantId}&view=moq`, function (data) {
        const minimumOrderQuantity = parseInt(data, 10);

        if (minimumOrderQuantity > 1) {
          // Check if the item needs to be updated
          if (!cartItem.properties || !cartItem.properties.hasOwnProperty('_moq') || cartItem.quantity < minimumOrderQuantity) {
            itemsToUpdate.push({
              id: cartItem.key,
              quantity: Math.max(cartItem.quantity, minimumOrderQuantity),
              properties: {
                ...cartItem.properties,
                _moq: minimumOrderQuantity
              }
            });
          }
        }

        itemsProcessed++;

        // If all items have been processed, update the cart
        if (itemsProcessed === cart.items.length) {
          if (itemsToUpdate.length > 0) {
            const updatePromises = itemsToUpdate.map(function (item) {
              return $.post('/cart/change.js', {
                id: item.id,
                quantity: item.quantity,
                properties: item.properties
              });
            });

            // Wait for all updates to complete
            $.when.apply($, updatePromises).done(function () {
              if (window.location.pathname === '/cart') {
                // Reload the page if on the cart template
                window.location.reload();
              } else {
                // Reload the cart drawer
                ajaxCart.load();
              }
            });
          }
        }
      });
    });
  });
});

function showMOQ(item) {
  const addedItem = item; // JSON contains the single added item
  if (!addedItem.properties || !addedItem.properties.hasOwnProperty('_moq')) {
    const productHandle = addedItem.handle;
    const variantId = addedItem.variant_id;

    // Fetch the minimum order quantity
    fetch(`/products/${productHandle}?variant=${variantId}&view=moq`)
      .then(function(response) {
        return response.text();
      })
      .then(function(data) {
        const minimumOrderQuantity = parseInt(data, 10);

        if (minimumOrderQuantity > 1) {
          // Update the cart item with the _moq property and adjust quantity if needed
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: addedItem.key,
              quantity: Math.max(addedItem.quantity, minimumOrderQuantity),
              properties: {
                ...addedItem.properties,
                _moq: minimumOrderQuantity
              }
            })
          })
            .then(function() {
              // Reload the cart after updating the item
              ajaxCart?.load();
            });
        } else {
          // Reload the cart if no update is needed
          ajaxCart?.load();
        }
      });
  } else {
    // Reload the cart if the _moq property already exists
    ajaxCart?.load();
  }  
}

$('body').on('afterChangeItem.ajaxCart', function(event, line, qty, cart) {
  var $row = $('.ajaxcart__row[data-line="' + line + '"]');  

  if($row.data('bundle-key')) {
    window.updateComponentsQuantity($row.data('bundle-key'), qty);
  }
});

$('.ajaxAddToCart').on('click', function(e) {
  e.preventDefault();
  var itemToAddToCart = $(this);

  $.post('/cart/add.js', {
    quantity: 1,
    id: itemToAddToCart.data('variant-id')
  },function(cart){
    showMOQ(cart);
    ajaxCart.load();
    theme.RightDrawer.open();
  }, 'json');
});

// Custom Simple Add to Cart
$('body').on('click', 'button.collection-add-to-cart', function(e) {
  e.preventDefault();
  var itemToAddToCart = $(this);
  itemToAddToCart.text("Adding..");
  itemToAddToCart.attr('disabled', true);

  $.post('/cart/add.js', {
    quantity: 1,
    id: itemToAddToCart.data('variant-id')
  },function(cart){
    showMOQ(cart);
    itemToAddToCart.text("Added");
    itemToAddToCart.attr('disabled', false);
    setTimeout(function() {
      itemToAddToCart.text("Buy Now") 
    }, 2000);
    ajaxCart.load();
    theme.RightDrawer.open();
  }, 'json');
});

$('.add-original-card:not(".add-bundle-to-cart") .add-to-cart').on('click', function(e) {
  e.preventDefault();
  var itemToAddToCart = $(this);

  $.post('/cart/add.js', {
    quantity: parseInt(itemToAddToCart.closest('.add-original-card').find('input[name="quantity"]').val()),
    id: itemToAddToCart.data('variant-id')
  },function(cart){
    showMOQ(cart);
    ajaxCart.load();
    theme.RightDrawer.open();
  }, 'json');
});

$('.add-bundle-to-cart .add-to-cart').on('click', function(e) {
  e.preventDefault();
  var itemToAddToCart = $(this);

  $.post('/cart/add.js', $(itemToAddToCart).closest('form').serialize(),function(product){
    itemToAddToCart.attr('disabled', true);
    itemToAddToCart.find('[data-add-to-cart-text]').text('Adding bundle to cart');
    var components = itemToAddToCart.closest('form').find('input[name="bundle_component_variant[]"]');
    var quantities = itemToAddToCart.closest('form').find('input[name="bundle_component_quantity[]"]');
    //var components_ids = [];
    var bundleItems = [];
    for(var i = 0; i<components.length; i++) {
      //components_ids.push($(components[i]).val());
      var bundleItem = {
        "id": $(components[i]).val(),
        "quantity": $(quantities[i]).val(),
        properties: {
          '_part_of_bundle': 'true',
          '_bundle_key': product.key,
          '_bundle_quantity': $(quantities[i]).val()
        }
      }
      bundleItems.push(bundleItem)
    }

     $.ajax({
      url: window.Shopify.routes.root + 'cart/add.js',
      dataType: 'json',
      type: 'post',
      data: {
        items: bundleItems
      },
      success: function(data) {  
        showMOQ(data);          
        $('.add-bundle-to-cart .add-to-cart').attr('disabled', false);
        $('.add-bundle-to-cart .add-to-cart').find('[data-add-to-cart-text]').text('Add to cart');
        ajaxCart.load();
        theme.RightDrawer.open();
      },
      error: function (data) {
        console.log(data);
      }
    })
    //addBundleComponents(product.key,components_ids);
  }, 'json');
});

$('body').on('click', '.grid__item--collection [data-add-to-cart]', function(e) {
  e.preventDefault();
  var itemToAddToCart = $(this);

  $.post('/cart/add.js', $(itemToAddToCart).closest('form').serialize(),function(cart){
    showMOQ(cart);
    ajaxCart.load();
    theme.RightDrawer.open();
  }, 'json');
});

function addBundleComponents(key,array) {
  if(array.length == 0) {    
    $('.add-bundle-to-cart .add-to-cart').attr('disabled', false);
    $('.add-bundle-to-cart .add-to-cart').find('[data-add-to-cart-text]').text('Add to cart');
    ajaxCart.load();
    theme.RightDrawer.open();
  } else {
    $.post('/cart/add.js', {
      id: array[0],
      quantity: 1,
      properties: {
        '_part_of_bundle': 'true',
        '_bundle_key': key
      }
    },function(cart){
      array.shift();
      addBundleComponents(key,array);
    }, 'json');
  }
}

if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      showMOQ(line_item);
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]:not(.bundle-form)',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
    dataLayer.push({'event': 'view_cart'});
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      var cartCount = cart.item_count;
      $.each(cart.items, function(index, cartItem) {
        if(cartItem.properties != null && cartItem.properties['_part_of_bundle']) {
          cartCount = cartCount - cartItem.quantity;
        }
      });
      
      $cartCountSelector.html(cartCount).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    /* $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    }); */
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p class="ajaxcart__empty">' + "Your cart is currently empty." + '</p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      if(cartItem.product_type != "Stamp") {
        var itemProperties = {},
            isSendGreetingCard = false,
            isBundle = false,
            bundleComponents = '',
            bundleQuantities = '',
            isBundleComponent = false,
            stampProductImage = false,
            stampProductTitle = false,
            stampProductPrice = false,
            itemMOQ = 1;

        /* Hack to get product image thumbnail
        *   - If image is not null
        *     - Remove file extension, add _small, and re-add extension
        *     - Create server relative link
        *   - A hard-coded url of no-image
        */
        if (cartItem.image != null){
          var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
        } else {
          var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        }

        if(cartItem.properties != null && cartItem.properties['_bundle-components']) {
          isBundle = true;
          bundleComponents = cartItem.properties['_bundle-components'].join(', ');
        }
        if(cartItem.properties != null && cartItem.properties['_part_of_bundle']) isBundleComponent = true;

        if(cartItem.product_type.includes('Write & Send') && cartItem.properties) {
          if(cartItem.properties.hasOwnProperty("To:")) {
            isSendGreetingCard = true;
            itemProperties = {
              "To:": cartItem.properties["To:"]
            }
            if(cartItem.properties["Future Delivery Date:"] != "") itemProperties["Future Delivery Date:"] = cartItem.properties["Future Delivery Date:"];
            if(cartItem.properties["stamp id"] == 36878356447389) {
              stampProductImage = "https://cdn.shopify.com/s/files/1/0353/9252/0251/products/earthdayforever.png?v=1628092860";
              stampProductTitle = "Forever Stamp - USA";

              $.each(cart.items, function(index, cartTempItem) {
                if(cartTempItem.variant_id == 36878356447389) {
                  stampProductPrice = cartTempItem.original_price;
                }
              })

            }
            if(cartItem.properties["stamp id"] == 36878795047069) {
              stampProductImage = "https://cdn.shopify.com/s/files/1/0353/9252/0251/products/chrysanthemumglobal.png?v=1628093089";
              stampProductTitle = "Global Forever Stamp"

              $.each(cart.items, function(index, cartTempItem) {
                if(cartTempItem.variant_id == 36878795047069) {
                  stampProductPrice = cartTempItem.original_price;
                }
              })

            }
            if(cartItem.properties["stamp id"] == 36894263247005) {
              stampProductImage = "https://cdn.shopify.com/s/files/1/0353/9252/0251/products/images.jpg?v=1603892545";
              stampProductTitle = "Celebration Forever Stamp";

              $.each(cart.items, function(index, cartTempItem) {
                if(cartTempItem.variant_id == 36894263247005) {
                  stampProductPrice = cartTempItem.original_price;
                }
              })

            }
          }
        } else {
          itemProperties = cartItem.properties;
          if (itemProperties.hasOwnProperty("_moq")) {
            itemMOQ = itemProperties["_moq"];
            delete itemProperties["_moq"];
          }
        }

        var hasMOQ = false;
        if(itemMOQ > 1) {
          hasMOQ = true;
        }

        // Create item's data object and add to 'items' array
        item = {
          key: cartItem.key,
          line: index + 1, // Shopify uses a 1+ index in the API
          url: cartItem.url,
          img: prodImg,
          name: cartItem.product_title,
          variation: cartItem.variant_title,
          properties: itemProperties,
          itemMOQ: itemMOQ,
          hasMOQ: hasMOQ,
          itemAdd: cartItem.quantity + 1,
          itemMinus: cartItem.quantity - 1,
          itemQty: cartItem.quantity,
          price: isBundle ? Shopify.formatMoney(cartItem.properties['_bundle-price'], settings.moneyFormat) : Shopify.formatMoney(cartItem.price, settings.moneyFormat),
          vendor: cartItem.vendor,
          linePrice: isBundle ? Shopify.formatMoney(cartItem.properties['_bundle-price'], settings.moneyFormat) : Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
          originalLinePrice: isBundle ? Shopify.formatMoney(cartItem.properties['_bundle-price'], settings.moneyFormat) : Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
          discounts: cartItem.discounts,
          discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
          isSendGreetingCard: isSendGreetingCard,
          isBundle: isBundle,
          bundleComponents: bundleComponents,
          isBundleComponent: isBundleComponent,
          stampProductImage: stampProductImage,
          stampProductTitle: stampProductTitle,
          stampProductPrice: Shopify.formatMoney(stampProductPrice, settings.moneyFormat),
        };

        items.push(item);
      }
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "Translation missing: en.cart.general.savings_html".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    }

    $cartContainer.append(template(data));

    cartCallback(cart);

    $("<style id='hideShipBar' type='text/css'> #CartContainer .ajaxcart__cart-order-free-shipping {display: none!important;} </style>").appendTo("head");
    setTimeout(function() {
      $.get({
        url: window.location.href,
        cache: false,
        success: function(response) {
            var parsed = $.parseHTML(response, document, true);
            var stringOfData = $(parsed).filter('#CartTemplate').html();
            var domData = new DOMParser().parseFromString(stringOfData, 'text/html');
            $('#CartContainer .free-shipping-bar').html($(domData).find('.free-shipping-bar').html());
            $('#CartContainer .free-shipping-progress-text').html($(domData).find('.free-shipping-progress-text').html());
            $('#hideShipBar').remove();

        }
      });
    }, 1000);
    
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, '')),
          moq = parseInt($qtySelector.attr('data-moq'));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
        if( qty < moq) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      if($el.attr('data-moq') && parseInt($el.val()) != 0 && parseInt($el.attr('data-moq')) > parseInt($el.val())) {
        qty = parseInt($el.attr('data-moq'));
      }

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]:not(.address-number)');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id'),
            inputMin = $el.attr('min'),
            inputMOQ = $el.attr('data-moq') ? parseInt($el.attr('data-moq')) : 1;

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId,
              inputMin: inputMin,
              inputMOQ: inputMOQ
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, '')),
            qtyMin = parseInt($qtySelector.attr('min')),
            moq = parseInt($qtySelector.attr('data-moq'));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= qtyMin) qty = qtyMin;
          if( moq && qty < moq) qty = 0;
        }

        // Update the input's number
        $qtySelector.val(qty);

        if($('.template-cart').length && $qtySelector.attr('id').split(':')[0].replace("updates_", "").length > 0) {


          var data = {
            "id": $qtySelector.attr('id').split(':')[0].replace("updates_", ""),
            "quantity": qty
          }
          
          jQuery.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: data,
            dataType: 'json',
            success: function() { 
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true  //this code is for prestige theme, is to refresh the cart
             }));
             $.ajax({
                url: window.location.href, 
                cache: false,
                success: function(response) {
                  if(qty == 0) {
                    $el.closest('.cart-item').remove();
                  }
                  $('.cart-order-summary').html($(response).find(".cart-order-summary").html());
                }
            });
            }
          });


          setTimeout(function() {

            $.ajax({
              url: window.location.href, 
              cache: false,
              success: function(response) {
                  if(qty == 0) {
                    $el.closest('.cart-item').remove();
                  }
                  $('.cart-order-summary').html($(response).find(".cart-order-summary").html());
              }}, 1000);
          });
        }
      });

      $('.js-qty__num').on('change', function() {
        if($(this).attr('min') && parseInt($(this).attr('min')) > parseInt($(this).val())) {
          $(this).val($(this).attr('min'));
        }
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));